import React, { useRef } from "react";
import Heading from "../../../Components/Heading/Heading";
import SectDescription from "../../../Components/Heading/SectDescription";
import { useState } from "react";
import { useEffect } from "react";
import { AiFillStar } from "react-icons/ai";
import { Link } from "react-router-dom";
import { GiSofa } from "react-icons/gi";
import { Skeleton } from "antd";

const BestDeal2 = ({ slug, bestDealData, skeletonForBestDealArray, SkeletonLoad }) => {
  const BestDealRef = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        setIsIntersecting(true);
        observer.disconnect();
      }
    });

    const observedNode = BestDealRef.current;
    if (observedNode) {
      observer.observe(observedNode);
    }

    return () => {
      if (observedNode) {
        observer.unobserve(observedNode);
      }
    };
  }, []);

  return (
    <div className="my-5 md:my-5 lg:my-10 xl:my-10" ref={BestDealRef}>
      {isIntersecting && (
        <>
          <Heading spanHeading={`Top Bargains ${slug ? `For ${slug}` : ""}`} />
          <SectDescription SectDescription="Big savings, stylish spaces: explore 'Top Bargains' for your dream home interiors." />
          <div className="site-container mt-5">
            {SkeletonLoad ? (
              <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 lg:gap-4 2xl:grid-cols-5">
                {skeletonForBestDealArray.map((index) => (
                  <div key={index} className="min-w-0">
                    <Skeleton.Node
                      active={true}
                      style={{ height: "100%", width: "100%", aspectRatio: "1 / 1" }}
                    >
                      <GiSofa style={{ fontSize: 100, color: "#bfbfbf" }} />
                    </Skeleton.Node>
                    <Skeleton active={true} className="mt-2" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 lg:gap-4 2xl:grid-cols-5">
              {bestDealData && bestDealData.map((el, i) => {
                return (
                  <div
                    className="mobile-listintg-card relative m-0 flex min-w-0 w-full flex-col overflow-hidden border border-gray-200 bg-white shadow-sm transition-shadow duration-300 hover:shadow-md"
                    key={i}
                  >
                    <Link
                      to={`/single-product/${el.id}`}
                      className="relative block aspect-square w-full overflow-hidden bg-gray-50"
                    >
                      <img
                        src={
                          process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.image
                        }
                        alt={el.name || "Fina Interiors product"}
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                      />
                    </Link>
                    <div className="flex w-full min-w-0 flex-col gap-1 border-t bg-white px-2 py-2">
                      <div className="flex justify-between mx-1">
                        <Link
                          to={`/single-product/${el.id}`}
                          className="font-[700] whitespace-nowrap overflow-hidden overflow-ellipsis break-normal text-[13px] w-2/3 capitalize tracking-wider mt-0.5"
                        >
                          {el.name}
                        </Link>
                        {/* <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            className="mt-0.5"
                          >
                            <Heart
                              isActive={el.is_wishlist === 1 ? true : false}
                              onClick={() =>
                                el.is_wishlist === 1
                                  ? handleDeleteWishlist(el)
                                  : handleHeartClick(el.id)
                              }
                              animationScale={1.25}
                              style={{ width: 20 }}
                            />
                          </div> */}
                      </div>

                      <div className="mx-1">
                        <p className="text-gray-700 text-xs md:text-sm lg:text-sm xl:text-xs font-bold text-start tracking-wide">
                          By {el.brand_name}
                        </p>
                        {/* <div className="w-[85%]">
                    <p className="text-gray-700 text-xs md:text-sm lg:text-sm xl:text-xs whitespace-nowrap overflow-hidden overflow-ellipsis">
                      {el.properties}
                    </p>
                  </div> */}
                      </div>
                      <div className="hidden md:block lg:block xl:block">
                        <div className="flex gap-2 items-center justify-between mx-1">
                          <div className="flex gap-2 items-center">
                            <p className="font-semibold text-xs tracking-wide">
                              Rs {parseInt(el.discounted_price)}/-
                            </p>
                            {parseInt(el.discounted_percent) === 0 ? (
                              false
                            ) : (
                              <strike className="text-gray-700 text-xs">
                                {parseInt(el.actual_price)}/-
                              </strike>
                            )}
                          </div>
                          <div className="">
                            <div className="flex gap-2 items-center">
                              <span className="flex items-center gap-0.5 p-0.5 text-sm text-gray-800 font-bold text-[12px]">
                                <AiFillStar
                                  size={16}
                                  className="text-green-600"
                                />
                                {el.rating}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="block md:hidden lg:hidden xl:hidden mb-0">
                        <div className="flex justify-between px-0.5">
                          <div className="flex gap-1 items-center text-xs">
                            <p className="text-xs font-semibold tracking-wide">
                              Rs {parseInt(el.discounted_price)}/-
                            </p>
                            {parseInt(el.discounted_percent) === 0 ? (
                              false
                            ) : (
                              <strike className="text-gray-700 text-xs">
                                {parseInt(el.actual_price)}/-
                              </strike>
                            )}
                          </div>
                          <div className="flex gap-2 items-center">
                            <div className="flex gap-2 items-center bg-white bg-opacity-70 backdrop-filter backdrop-blur-md rounded">
                              <span className="flex items-center gap-0.5 p-0.5 px-1 text-sm text-green-600">
                              {el.rating}
                                <AiFillStar
                                  size={16}
                                  className="mt-0.5 text-green-600"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {parseInt(el.discounted_percent) === 0 ? (
                      false
                    ) : (
                      <div className="absolute top-[4.5px] bg-white rounded-br-lg">
                        <div className="p-1 px-1.5 flex items-center">
                          <img src="/percent.png" alt="" className="w-[12px]" />
                          <p className="text-green-500 font-bold text-xs">
                            {parseInt(el.discounted_percent)}% Off
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default BestDeal2;
